"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewpointModeResultType = exports.ViewpointEventType = void 0;
let ViewpointModeResultType = exports.ViewpointModeResultType = /*#__PURE__*/function (ViewpointModeResultType) {
  ViewpointModeResultType["SAVE"] = "SAVE";
  ViewpointModeResultType["DISCARD"] = "DISCARD";
  return ViewpointModeResultType;
}({});
let ViewpointEventType = exports.ViewpointEventType = /*#__PURE__*/function (ViewpointEventType) {
  ViewpointEventType["VIEWPOINT_MODE_ENABLED_CHANGE"] = "viewpointModeEnabledChange";
  return ViewpointEventType;
}({});
/**
 * The ViewpointExtension interface is currently implemented by the GGMarkupsExtension and can be used to start the extension
 * in viewpoint mode.
 */
//# sourceMappingURL=ViewpointExtensionType.js.map